<template>
  <div class="max-w-360 m-auto w-full pt-1 pb-6 size-full flex flex-col items-center p-6">
    <div class="w-full">
      <div class="rounded-5xl flex-1">
        <component :is="currentCom"></component>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue'
  import Settings from './settings/index.vue'
  import Configurations from './configurations/index.vue'
  import { useRoute } from 'vue-router'

  const route = useRoute()

  const currentCom = computed(() => {
    if (!route.query.com) {
      return null
    }
    switch (route.query.com) {
      case 'settings':
        return Settings
      case 'configurations':
        return Configurations
      default:
        return null
    }
  })
</script>

<style lang="scss" scoped></style>
